module.exports = __webpack_public_path__ + "img/Algeria.d05a0be2.png";